import React, { useMemo } from 'react';
import { Box,Inscription } from '@common-fe/common-fe';

import { Intersection } from './queries/useGetAlreadyExistClaimsTeams.query';
import { EllipsisText, IntersectionWrapper, TextWithPoint } from './MultipleServicesSelector.styles';
import ServicesList from './ServicesList';

interface Props {
  intersection: Intersection;
  amountOfAllServices?: number;
}

const IntersectionNotification: React.FC<Props> = ({ intersection, amountOfAllServices }) => {
  const services = useMemo(() => intersection?.intersectionServices?.sort((a, b) => {
    const typeA = a?.categoryType || '';
    const typeB = b?.categoryType || '';
    if (typeA < typeB) return -1;
    if (typeA > typeB) return 1;
    return 0;
  }), [intersection]);

  return (
    <IntersectionWrapper
      direction="row"
      align="center"
      pad={{ horizontal: 'spacing12' }}
    >
      <Box data-testId={`intersection_team_name_${intersection?.teamName}`}>
        <Inscription weight="bold" lineHeight="20px">{intersection?.teamName}</Inscription>
      </Box>
      <Box data-testId="intersection_organizations">
        {intersection?.intersectionOrganizations?.map((organization) => (
          <TextWithPoint key={organization?.id}>
            <EllipsisText
              lineHeight="20px"
              title={organization?.name}
            >
              {organization?.name}
            </EllipsisText>
          </TextWithPoint>
        ))}
      </Box>
      <Box data-testId="intersection_services">
        {intersection.isGeneric ? (
          <Inscription lineHeight="20px">All services ({amountOfAllServices})</Inscription>
        ) : <ServicesList services={services} />}
      </Box>
    </IntersectionWrapper>
  );
};

export default IntersectionNotification;
